<template>
<div>
    <img @click="setLang('pl')"  class="flag_img" src="/img/flags/poland.png">
    <img @click="setLang('en')"  class="flag_img" src="/img/flags/england.png">
    <img @click="setLang('fr')"  class="flag_img" src="/img/flags/france.png">
    <img @click="setLang('gr')"  class="flag_img" src="/img/flags/gregoria.png">
    <img @click="setLang('ru')"  class="flag_img" src="/img/flags/rusian.png">
    <img @click="setLang('ua')"  class="flag_img" src="/img/flags/ukraine.png">
    <img @click="setLang('es')"  class="flag_img" src="/img/flags/spain.png">
</div>
</template>

<script>

export default {
  name: "LangBar",
  methods:{
    setLang(lang){
      this.$store.commit("changeLanguage", lang)
    }
  }
}
</script>

<style scoped>
.flag_img{
  height: 30px;
  margin-left: 1rem;
  cursor: pointer;
}
</style>